import { Component, Input } from "@angular/core";
import {
  NavController,
  NavParams,
  IonicPage,
  ModalController,
  PopoverController,
  Events,
  AlertController,
} from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
import * as users from "../../actions/user.actions";
import { Auth } from "../../providers/auth/auth";

const reverse = require("lodash/reverse"); // tslint:disable-line
const sortBy = require("lodash/sortBy"); // tslint:disable-line

@Component({
  selector: "ww-header",
  templateUrl: "ww-header.html",
})
export class WwHeaderComponent {
  wwPlatform: Observable<any>;
  audit_calculations: any;

  @Input() title: string;
  filtersSubscription: Subscription;
  filter: any;

  constructor(
    public popoverCtrl: PopoverController,
    public navCtrl: NavController,
    public eventsCtrl: Events,
    public alertCtrl: AlertController,
    public store: Store<fromRoot.State>,
    public authProvider: Auth
  ) {
    this.wwPlatform = this.store.select(fromRoot.getPlatformInfo);
    this.filtersSubscription = this.store
      .select(fromRoot.getScreensFilter)
      .subscribe((f) => {
        this.filter = f;
      });

    this.audit_calculations = this.store
      .select(fromRoot.getUpdates)
      .map((arr) => {
        return arr.filter((u) => u.item == "calculate");
      })
      .filter((data) => data.length > 0)
      .map((data) => {
        return reverse(sortBy(data, (i) => i.updatedAt))[0];
      });
  }

  showMenu($event) {
    let popover = this.popoverCtrl.create("PopupMenuPage");

    popover.present({
      ev: $event,
    });

    popover.onDidDismiss((page) => {
      if (page && page.name) {
        console.log("Got page:", page);
        if (page.logsOut) {
          this.logout();
        } else {
          this.navCtrl.setRoot(page.name);
        }
      }
    });
  }

  showSearch(myEvent) {
    let popover = this.popoverCtrl.create(
      "TopSearchPopoverPage",
      {},
      {
        showBackdrop: true,
        enableBackdropDismiss: true,
        cssClass: "search--popover",
      }
    );
    popover.present({
      ev: myEvent,
    });

    popover.onDidDismiss((ticker) => {
      if (ticker) {
        this.navCtrl.push("CompanyContainerPage", { ticker });
      }
    });
  }

  goHome() {
    this.navCtrl.setRoot("HomePage");
  }

  goToFullCoverage() {
    let filter = { ...this.filter };
    filter.screens = {};
    this.eventsCtrl.publish("openPage", "ScreensPage");
    this.store.dispatch(new users.UpdateFilter({ filter }));
  }

  logout() {
    const alert = this.alertCtrl.create({
      title: "Logout",
      subTitle: "Are you sure?",
      buttons: [
        {
          text: "Cancel",
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: "Logout",
          handler: () => {
            setTimeout(() => {
              this.eventsCtrl.publish("openPage", "LoginPage");
            }, 200);
            this.authProvider.logout();
            this.navCtrl.push("LoginPage");
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/ww-header/ww-header.ts